(function () {
  'use strict';
  var entering = false, adding = false;
  function route(path) { return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + path; }
  async function request(url, options) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 15000);
    try { return await fetch(url, Object.assign({}, options, {signal:controller.signal})); }
    finally { window.clearTimeout(timeout); }
  }
  function step() { return document.querySelector('[data-zr-bundle-step]'); }
  function formMessage(form, message) {
    var status = form.querySelector('[data-zr-checkout-status]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-zr-checkout-status', '');
      status.setAttribute('role', 'status');
      form.querySelector('.cart__checkout-wrapper').appendChild(status);
    }
    status.textContent = message;
  }
  function waitForQuantityUpdates(form) {
    return new Promise(function (resolve, reject) {
      var started = Date.now();
      function check() {
        if (!form.querySelector('.js-qty__wrapper.is-loading')) { resolve(); return; }
        if (Date.now() - started > 8000) { reject(new Error('Your cart is still updating. Please try again when it finishes.')); return; }
        window.setTimeout(check, 50);
      }
      check();
    });
  }
  function stepMessage(message) {
    var root = step(), status = root && root.querySelector('[data-zr-step-status]');
    if (status) { status.textContent = message; status.focus(); }
  }
  function setStepBusy(value) {
    var root = step();
    if (!root) return;
    root.setAttribute('aria-busy', value ? 'true' : 'false');
    root.querySelectorAll('[data-zr-pick-add], [data-zr-step-continue], [data-zr-pick-variant]').forEach(function (el) { el.disabled = value; });
    root.querySelectorAll('a').forEach(function (a) {
      if (value) a.setAttribute('aria-disabled', 'true');
      else a.removeAttribute('aria-disabled');
    });
  }
  function syncArtwork(root) {
    root.querySelectorAll('[data-zr-pick-variant]').forEach(function (select) {
      var option = select.selectedOptions[0], image = select.closest('.zr-cart-pick').querySelector('img');
      if (option && option.dataset.image && image) {
        image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = option.dataset.image;
      }
    });
  }
  // Native form submission remains the fallback when JavaScript or the offer is unavailable.
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (form.matches('[data-zr-step-checkout]')) {
      if (adding) { event.preventDefault(); return; }
      // This is the final standard Shopify checkout POST; do not intercept it again.
      return;
    }
    if (!form.matches('form[data-zr-offer-url]')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    if (!form.querySelector('[data-zr-bundle-eligible="true"]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (entering) return;
    var terms = form.querySelector('.cart__terms-checkbox');
    if (terms && !terms.checked) {
      formMessage(form, 'Please accept the terms before continuing.'); terms.focus(); return;
    }
    var button = form.querySelector('[name="checkout"]');
    entering = true; button.disabled = true; button.classList.add('btn--loading');
    formMessage(form, '');
    try {
      await waitForQuantityUpdates(form);
      var note = form.querySelector('[name="note"]');
      if (note) {
        var response = await request(route('cart/update.js'), {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({note:note.value})});
        if (!response.ok) throw new Error('Your order note could not be saved. Please try again.');
      }
      window.location.assign(form.dataset.zrOfferUrl);
    } catch (error) {
      formMessage(form, error.message || 'Unable to continue. Please try again.');
      entering = false; button.disabled = false; button.classList.remove('btn--loading');
    }
  }, true);
  document.addEventListener('click', async function (event) {
    var root = step();
    if (!root || !root.contains(event.target)) return;
    if (adding && event.target.closest('a')) { event.preventDefault(); return; }
    var button = event.target.closest('[data-zr-pick-add]');
    if (!button) return;
    event.preventDefault();
    if (adding) return;
    var card = button.closest('.zr-cart-pick'), select = card.querySelector('[data-zr-pick-variant]');
    if (!select || !select.value) return;
    adding = true; setStepBusy(true); button.textContent = 'Adding…';
    var committed = false, reloading = false;
    try {
      var response = await request(route('cart/add.js'), {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:select.value,quantity:1}]})});
      var result = await response.json().catch(function () { return {}; });
      if (!response.ok) {
        var rejected = new Error(result.description || result.message || 'This print could not be added. Please choose another.');
        rejected.confirmedRejection = true; throw rejected;
      }
      committed = true;
      // Refresh from Shopify so counts, available offers and subtotal reflect actual cart discounts.
      var fresh = await request(route('?section_id=zr-bundle-step'), {credentials:'same-origin',cache:'no-store'});
      if (!fresh.ok) throw new Error('refresh');
      var html = await fresh.text();
      var replacement = new DOMParser().parseFromString(html,'text/html').querySelector('[data-zr-bundle-step]');
      if (!replacement) throw new Error('refresh');
      root.replaceWith(replacement);
      syncArtwork(replacement);
      var checkout = replacement.querySelector('[data-zr-step-continue]');
      if (checkout) checkout.textContent = 'Continue to checkout';
      stepMessage('Print added to your order.');
      document.dispatchEvent(new CustomEvent('cart:build'));
    } catch (error) {
      if (committed) {
        // The add succeeded: reload the cart view rather than invite a duplicate add.
        reloading = true; window.location.reload(); return;
      }
      stepMessage(error.confirmedRejection ? error.message : 'We could not confirm the addition. Check your cart before trying again.');
    } finally {
      if (!reloading) {
        adding = false; setStepBusy(false);
        if (button.isConnected) button.textContent = 'Add print';
      }
    }
  });
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-zr-bundle-step] [data-zr-pick-variant]')) syncArtwork(step());
  });
  document.addEventListener('DOMContentLoaded', function () {
    var root = step();
    if (!root) return;
    syncArtwork(root);
    // An empty recommendation pool must not add an unnecessary checkout obstacle.
    if (root.dataset.hasOffers === 'false' && Number(root.dataset.cartCount) > 0) {
      var form = root.querySelector('[data-zr-step-checkout]');
      if (form && !form.querySelector('[required]') && form.requestSubmit) form.requestSubmit(form.querySelector('[name="checkout"]'));
    }
  });
  window.addEventListener('pageshow', function () {
    entering = false; adding = false;
    document.querySelectorAll('form[data-zr-offer-url] [name="checkout"]').forEach(function (button) { button.disabled = false; button.classList.remove('btn--loading'); });
    setStepBusy(false);
  });
  function resizeQuantity(input) {
    var digits = Math.max(2, String(input.value || '').length);
    input.closest('.js-qty__wrapper').style.setProperty('--zr-quantity-digits', digits);
  }
  function resizeCartQuantities() {
    document.querySelectorAll('#CartDrawerForm .js-qty__num, #CartPageForm .js-qty__num').forEach(resizeQuantity);
  }
  document.addEventListener('input', function (event) {
    if (event.target.matches('#CartDrawerForm .js-qty__num, #CartPageForm .js-qty__num')) resizeQuantity(event.target);
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('#CartDrawerForm .js-qty__adjust, #CartPageForm .js-qty__adjust')) window.setTimeout(resizeCartQuantities, 0);
  });
  document.addEventListener('change', function (event) {
    if (event.target.matches('#CartDrawerForm .js-qty__num, #CartPageForm .js-qty__num')) resizeQuantity(event.target);
  });
  document.addEventListener('DOMContentLoaded', function () {
    resizeCartQuantities();
    document.querySelectorAll('#CartDrawerForm [data-products], #CartPageForm [data-products]').forEach(function (container) {
      new MutationObserver(resizeCartQuantities).observe(container, {childList:true,subtree:true});
    });
  });
  document.addEventListener('cart:updated', function () { window.setTimeout(resizeCartQuantities, 0); });
}());
